<div *ngIf="data" style="margin-top: 25px; text-align: left !important;">
  <mat-tab-group class="tabsCodeEx">

    <!-- EASY -->
    <mat-tab *ngIf="data.licenses.wizard" label="Easy">
      <div class="code-wrapper">
        <pre class="code-block">
          <button class="copy-btn" (click)="copyCode(htmlWizard)">Copy</button>
          <ng-container *ngFor="let line of htmlWizard.trim().split('\n'); let i = index">
            <span class="line">
              <span class="line-number">{{ i + 1 }}</span>
              <span class="line-text">{{ line }}</span>
            </span>
          </ng-container>
        </pre>
      </div>
    </mat-tab>

    <!-- SMART JS -->
    <mat-tab *ngIf="data.licenses.js" label="Smart (JS)">
      <ng-template matTabContent>
        <mat-tab-group [(selectedIndex)]="tabIndex">

          <!-- DEFAULT -->
          <mat-tab label="DEFAULT">
            <div class="code-wrapper">
              <pre class="code-block">
                <button class="copy-btn" (click)="copyCode(htmlJS)">Copy</button>
                <ng-container *ngFor="let line of htmlJS.trim().split('\n'); let i = index">
                  <span class="line">
                    <span class="line-number">{{ i + 1 }}</span>
                    <span class="line-text">{{ line }}</span>
                  </span>
                </ng-container>
              </pre>
            </div>
          </mat-tab>

          <!-- BUTTONLESS -->
          <mat-tab label="BUTTONLESS">
            <div class="code-wrapper">
              <pre class="code-block">
                <button class="copy-btn" (click)="copyCode(htmlJSButtonless)">Copy</button>
                <ng-container *ngFor="let line of htmlJSButtonless.trim().split('\n'); let i = index">
                  <span class="line">
                    <span class="line-number">{{ i + 1 }}</span>
                    <span class="line-text">{{ line }}</span>
                  </span>
                </ng-container>
              </pre>
            </div>
          </mat-tab>

          <!-- COMPACT -->
          <mat-tab label="COMPACT">
            <div class="code-wrapper">
              <pre class="code-block">
                <button class="copy-btn" (click)="copyCode(htmlJSCompact)">Copy</button>
                <ng-container *ngFor="let line of htmlJSCompact.trim().split('\n'); let i = index">
                  <span class="line">
                    <span class="line-number">{{ i + 1 }}</span>
                    <span class="line-text">{{ line }}</span>
                  </span>
                </ng-container>
              </pre>
            </div>
          </mat-tab>

          <!-- INLINE -->
          <mat-tab label="INLINE (CREDITCARD)">
            <div class="code-wrapper">
              <pre class="code-block">
                <button class="copy-btn" (click)="copyCode(htmlJSinline)">Copy</button>
                <ng-container *ngFor="let line of htmlJSinline.trim().split('\n'); let i = index">
                  <span class="line">
                    <span class="line-number">{{ i + 1 }}</span>
                    <span class="line-text">{{ line }}</span>
                  </span>
                </ng-container>
              </pre>
            </div>
          </mat-tab>

        </mat-tab-group>
      </ng-template>
    </mat-tab>

    <!-- ANDROID -->
    <mat-tab *ngIf="data.licenses.android" label="Android">
      <div class="code-wrapper">
        <pre class="code-block">
          <button class="copy-btn" (click)="copyCode(htmlAndroid)">Copy</button>
          <ng-container *ngFor="let line of htmlAndroid.trim().split('\n'); let i = index">
            <span class="line">
              <span class="line-number">{{ i + 1 }}</span>
              <span class="line-text">{{ line }}</span>
            </span>
          </ng-container>
        </pre>
      </div>
    </mat-tab>

    <!-- IOS -->
    <mat-tab *ngIf="data.licenses.ios" label="iOS">
      <div class="code-wrapper">
        <pre class="code-block">
          <button class="copy-btn" (click)="copyCode(htmlIos)">Copy</button>
          <ng-container *ngFor="let line of htmlIos.trim().split('\n'); let i = index">
            <span class="line">
              <span class="line-number">{{ i + 1 }}</span>
              <span class="line-text">{{ line }}</span>
            </span>
          </ng-container>
        </pre>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
